import React, { useRef } from "react";
import PageStyle from "@/styles/components/request-for-more/_index.module.scss";
import AutomationStyle from "@/styles/components/automation-popup/_index.module.scss";
import { InfoModalStyle, Close } from "@/imports-files/components/common-modal/common-modal";
import { useTranslation } from "react-i18next";

export function IntegrationPopup({ onClose }) {
  const modalRef = useRef(null);

  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      onClose();
    }
  };

  const handleClickInside = (event) => {
    event.stopPropagation();
  };

  const {t} = useTranslation()

  return (
    <div
      className={`${InfoModalStyle.ModalOverlay}`}
      onClick={handleClickOutside}
    >
      <div
        className={`${InfoModalStyle.Modal}`}
        onClick={handleClickInside}
        ref={modalRef}
        style={{minHeight:"auto"}}
      >
        <div className={`${InfoModalStyle.Modal__Container}`}>
          <div
            className={`${InfoModalStyle.Modal__Container__CloseSection}`}
            onClick={onClose}
          >
            <Close/>
          </div>
          <div className={InfoModalStyle.Modal__Container__ContentSection}>
            <ul
              className={`${InfoModalStyle.Modal__Container__ContentSection__Description}`}
              style={{ height: "auto" }}
            >
              <li>
               {t('modal:info:g_meet:description')}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
